export const buildInfo = {
  appVersion: 'dev',
  appNativeVersion: '1.0',
  appflowBuildNumber: '',
  appflowBuildId: '',
  gitCommitSha: '',
  gitRef: '',
  platform: '',
  environment: '',
  builtAt: ''
} as const;